const normalizeToken = (token) => {
  if (!token) return '';
  const sanitizedToken = token.replace(/(^[\.\-\s]+)|([\.\-\s]+$)/g, '');
  return (sanitizedToken || token).trim().toLowerCase();
}

const defaultIsDelimiter = (char) => {
  return /[^\w\-\.%]/.test(char);
}

const tokenize = (str, isDelimiter = defaultIsDelimiter) => {
  const result = [];
  let currentTokenStartIndex = -1;

  for (let i = 0; i < str.length; i++) {
    const char = str[i];

    if (isDelimiter(char)) {
      if (currentTokenStartIndex >= 0) {
        const token = normalizeToken(str.substring(currentTokenStartIndex, i));

        if (token) {
          result.push({
            index: currentTokenStartIndex, 
            endIndex: i,
            token
          });
        }
        
        currentTokenStartIndex = -1;
      }
    } else {
      if (currentTokenStartIndex < 0) currentTokenStartIndex = i;
    }
  }

  if (currentTokenStartIndex >= 0) {
    result.push({
      index: currentTokenStartIndex, 
      endIndex: str.length,
      token: normalizeToken(str.substring(currentTokenStartIndex))
    });
  }

  return result;
}

const findLongestCommonTokenSequence = (tokens1, tokens2) => {
  if (!tokens1.length || !tokens2.length) return { longestSequence: [], longestSequenceWeight: 0 };
  let longestSequence = [];
  let longestSequenceWeight = 0;
  let bestPossibleWeight = tokens2.reduce((sum, token) => sum + token.token.length, 0);

  for (let i = 0; i < tokens1.length; i++) {
    for (let j = 0; j < tokens2.length; j++) {
      if (tokens1[i].token !== tokens2[j].token && 
        !tokens1[i].token.endsWith(tokens2[j].token)) {
        continue;
      }

      const currentSequence = [];
      let currentSequenceWeight = 0;

      for (let k = j; k < tokens2.length; k++) {
        const token1 = tokens1[i + k - j];
        if (!token1) break;
        const token2 = tokens2[k];

        if (token1.token === token2.token) {
          currentSequence.push(token1);
          currentSequenceWeight += token1.token.length;
        } else if (k === j && token1.token.endsWith(token2.token)) {
          currentSequence.push({
            index: token1.index + token1.token.indexOf(token2.token), 
            endIndex: token1.endIndex,
            token: token2.token,
          });
          currentSequenceWeight += token2.token.length - (token1.token.length - token2.token.length);
        } else if (k === tokens2.length - 1 && token1.token.startsWith(token2.token)) {
          currentSequence.push({
            index: token1.index,
            endIndex: token1.index + token2.token.length,
            token: token2.token,
          });
          currentSequenceWeight += token2.token.length - (token1.token.length - token2.token.length);
        } else {
          break;
        }
      }

      if (currentSequenceWeight > longestSequenceWeight) {
        longestSequence = currentSequence;
        longestSequenceWeight = currentSequenceWeight;
      }

      if (currentSequenceWeight === bestPossibleWeight) {
        return { longestSequence, longestSequenceWeight };
      }
    }
  }
  
  return { longestSequence, longestSequenceWeight };
}

export { tokenize, findLongestCommonTokenSequence };